import React from 'react'
import { Link } from 'react-router-dom'
import { FileCheck, FileText, Briefcase, Percent, ArrowRight, ArrowUpRight } from 'lucide-react'

const allServicesList = [
  {
    path: '/regnskabsservice',
    title: 'Samlet Regnskabsservice',
    tag: 'Mest populære',
    description: 'Komplet pakke med løbende bogføring, moms, årsregnskab og selvangivelse til en fast årlig pris inkl. regnskabsprogram.',
    icon: Briefcase
  },
  {
    path: '/bogfoering',
    title: 'Bogføring & Moms',
    tag: 'Løbende hjælp',
    description: 'Håndtering af bilag, afstemning af bank og korrekt momsindberetning, så du altid har styr på de løbende tal.',
    icon: FileCheck
  },
  {
    path: '/aarsrapport-og-aarsregnskab',
    title: 'Årsrapport & Årsregnskab',
    tag: 'Årets afslutning',
    description: 'Korrekt opstilling af årsrapport, resultatopgørelse, balance og rettidig indberetning til Erhvervsstyrelsen.',
    icon: FileText
  },
  {
    path: '/ydelser/personlig-selvangivelse',
    title: 'Personlig Selvangivelse',
    tag: 'Skatteoptimering',
    description: 'Hjælp til årsopgørelse, forskudsopgørelse, udlejningsejendom (VSO), forældrekøb og værdipapirer.',
    icon: Percent
  }
]

export default function RelatedServices({ currentPath = '', title = 'Se også vores andre ydelser' }) {
  // Filtrer den aktuelle ydelse fra, så vi viser de andre ydelser
  const items = allServicesList.filter((s) => s.path !== currentPath)

  return (
    <section className="py-16 lg:py-20 bg-stone-100/70 border-t border-stone-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-orange-600">
              Ydelser & Rådgivning
            </span>
            <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight mt-1">
              {title}
            </h2>
            <p className="text-sm sm:text-base text-stone-600 mt-2 max-w-2xl">
              Vi hjælper selvstændige og mindre virksomheder med alt fra løbende bogføring til det færdige årsregnskab.
            </p>
          </div>
          <Link
            to="/ydelser"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-orange-600 hover:text-orange-700 underline underline-offset-4 shrink-0"
          >
            Se alle ydelser & priser
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.slice(0, 3).map((item) => {
            const Icon = item.icon
            return (
              <Link
                key={item.path}
                to={item.path}
                className="group bg-white border border-stone-200 p-6 sm:p-7 shadow-sm hover:border-orange-500/60 hover:shadow-md transition-all duration-300 flex flex-col justify-between"
              >
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <div className="h-10 w-10 bg-orange-50 border border-orange-200 flex items-center justify-center text-orange-600">
                      <Icon className="h-5 w-5" />
                    </div>
                    <span className="text-[11px] font-semibold text-stone-500 bg-stone-100 px-2 py-0.5 border border-stone-200">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-stone-900 group-hover:text-orange-600 transition-colors flex items-center justify-between">
                    <span>{item.title}</span>
                    <ArrowUpRight className="h-4 w-4 text-stone-400 group-hover:text-orange-600 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </h3>
                  <p className="text-stone-600 text-sm leading-relaxed mt-2.5">
                    {item.description}
                  </p>
                </div>
                <div className="mt-6 pt-4 border-t border-stone-100 flex items-center text-xs font-semibold text-orange-600 group-hover:text-orange-700">
                  <span>Læs mere om {item.title.toLowerCase()} &rarr;</span>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </section>
  )
}
